export default __webpack_public_path__ + "img/simplelogo.8e5732c8.png";